/**
 * ТЗ 0121 — режимы ширины ERP. ОДНО место на всё приложение.
 *
 *   телефон   ≤ MOBILE_MAX (767)
 *   планшет   768 … TABLET_MAX (1279) — это и есть `HEADER_COMPACT_MAX`
 *   компьютер ≥ 1280 — вид не меняется: всё мобильное стоит за этими
 *                       медиазапросами и хуками `useIsMobile` / `useIsTouch`
 *
 * Сенсорное поведение (нажатие вместо наведения) решает `(hover: none)`, а не
 * ширина: планшет в альбомной ориентации остаётся с компьютерной раскладкой,
 * но наведения у него нет.
 */
import { HEADER_COMPACT_MAX } from './headerBreakpoints';

export const MOBILE_MAX = 767;
export const TABLET_MAX = HEADER_COMPACT_MAX;

/** Высота мобильной шапки и нижней панели вкладок (без safe-area). */
export const MOBILE_HEADER_HEIGHT = 56;
export const MOBILE_TABBAR_HEIGHT = 56;

/** Голые условия — для `matchMedia` (`useMediaQuery`). */
export const MEDIA_QUERIES = {
  mobile: `(max-width: ${MOBILE_MAX}px)`,
  tablet: `(min-width: ${MOBILE_MAX + 1}px) and (max-width: ${TABLET_MAX}px)`,
  /** Телефон или планшет — всё, что уже компьютера. */
  belowDesktop: `(max-width: ${TABLET_MAX}px)`,
  touch: '(hover: none)',
} as const;

/** Готовые `@media` для styled-components: `${mq.mobile} { … }`. */
export const mq = {
  mobile: `@media ${MEDIA_QUERIES.mobile}`,
  tablet: `@media ${MEDIA_QUERIES.tablet}`,
  belowDesktop: `@media ${MEDIA_QUERIES.belowDesktop}`,
  touch: `@media ${MEDIA_QUERIES.touch}`,
  /** Есть наведение (мышь) — сюда переезжают правила `:hover`-меню. */
  hover: '@media (hover: hover)',
} as const;
